
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
@Component
export default class SelectAirport extends Vue {
  private indexList: any = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'W', 'X', 'Y', 'Z'];
  private airports: any = {}
  private $api: any;

  private isPopShow: boolean = false; // 隐藏下拉框
  @Prop({default: false}) private isPopOpen: any; // 隐藏下拉框(父组件控制)
  private selectedDate: any = {
    cityCName: '',
  };
  // 接收父组件的值
  @Prop() private label: any; // 输入框左侧文字
  @Prop() private placeholder: any;
  @Prop() private title: any; // 下拉框title
  @Prop() private columns: any; // 数据数组
  @Prop() private editVal: any; // 编辑的获取到的值
  @Prop({default: false}) private hideField: any;

  @Watch('isPopOpen')
  private onPopOpen() {
    this.isPopShow = this.isPopOpen;
  }

  private mounted() {
    if (this.editVal ) {
      this.findInfo(this.editVal.airportCode);
    } else {
      this.selectedDate = {};
    }
  }

  // 编辑时根据三字码获取机场详细信息
  private findInfo(val: any) {
    for (let index of Object.keys(this.airports)) {  
      this.airports[index].find((v: any) => {
        if (v.airportCode === val) {
          this.selectedDate = v;
          return;
        }
      });
    }
  }

  // 确定
  private chooseCity(val: any) {
      this.selectedDate = val;
      this.$emit('input',  this.selectedDate);
      this.onCancel();
  }
  // 隐藏弹框
  private onCancel() {
    this.isPopShow = false;
    
  }

  private emitCancel() {
    this.$emit('cancel');
  }


  private async created() {
    const result = await this.$api.httpGet("Membership/TripBookTicket/GetAirportsDic",null);
    if (result.Success) {
      for (let key in result.Data) {
        result.Data[key] = result.Data[key].map(function (item: any) {
          return {
            airportCode: item.AirportCode,
            airportCName: item.AirportCName,
            cityCode: item.CityCode,
            cityCName: item.CityCName,
            isHot: item.IsHot,
            domesticProvince: item.DomesticProvince,
          };
        });
      }
      this.airports = result.Data;
    }
  }
}
